<h4 mat-dialog-title>{{data.message}}</h4>
<div mat-dialog-content>
  <section fxLayout="column wrap">
    <ng-container *ngFor="let value of data.values">
      <mat-checkbox disableRipple="true" (change)="setResults($event, value)">{{value}}</mat-checkbox>
    </ng-container>
  </section>
</div>
<div mat-dialog-actions style="justify-content: center;">
  <button mat-raised-button color="warn" (click)="cancel()">Annulla</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="results">Conferma</button>
</div>
